import { KioskStateType } from "../../KioskReducer"
import { ActionType } from "../../Actions"
import { PRINTER_SET } from "../../Actions/Kiosk/printerSetAction";
import { storageKeyPrinter } from "../../../model/StorageKeys";
import storeState from '../../../utils/storeState'

export default function printerReducer(
  state: KioskStateType,
  action: ActionType
): KioskStateType {
  switch(action.type) {
    case PRINTER_SET:
      storeState(storageKeyPrinter, action.payload.printer);
      return {
        ...state,
        printer: action.payload.printer
      }
  }

  return state;
}
